import React, { useState } from 'react';
import { X, Zap, Send, Loader } from 'lucide-react';
import { config } from '../../config';

const ContentManagerModal = ({ onClose }) => {
    const [loading, setLoading] = useState(false);
    const [stream, setStream] = useState('All');

    const handlePush = async () => {
        if (!confirm(`Are you sure you want to push updates for ${stream} streams? This will update all Client Sheets.`)) {return;}

        setLoading(true);
        try {
            await fetch(`${config.API_BASE_URL}/webhook/hq-push-updates`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'push_content_updates',
                    stream: stream,
                    adminEmail: config.USER_EMAIL
                })
            });
            alert('Updates Pushed Successfully!');
            onClose();
        } catch (error) {
            console.error(error);
            alert('Failed to push updates.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200 relative">

                <div className="bg-amber-50 border-b border-amber-100 p-6 flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <div className="bg-amber-100 p-2 rounded-xl text-amber-600">
                            <Zap size={20} />
                        </div>
                        <div>
                            <h2 className="text-xl font-black text-slate-800">Content Manager</h2>
                            <p className="text-xs text-slate-500 font-medium">Push updates to Playbooks</p>
                        </div>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full text-slate-400 hover:text-slate-600 transition-colors">
                        <X size={20} />
                    </button>
                </div>

                <div className="p-8">
                    <p className="text-sm text-slate-600 mb-6">
                        This action will synchronize the <b>Master_Content</b> library with all active Client Sheets. New tasks and playbook verification tabs will be created.
                    </p>

                    <div className="mb-6">
                        <label className="block text-sm font-bold text-slate-700 mb-2">Target Program Stream</label>
                        <select
                            value={stream}
                            onChange={(e) => setStream(e.target.value)}
                            className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:border-amber-500 outline-none"
                        >
                            <option value="All">All Streams</option>
                            <option value="Executive">Executive Coaching</option>
                            <option value="Business">Business Building</option>
                        </select>
                    </div>

                    <button
                        onClick={handlePush}
                        disabled={loading}
                        className="w-full bg-amber-500 hover:bg-amber-600 text-white py-4 rounded-xl font-bold uppercase tracking-widest flex items-center justify-center gap-2 transition-all shadow-lg shadow-amber-200 disabled:opacity-50"
                    >
                        {loading ? 'Pushing...' : <><Send size={20} /> Push Updates</>}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContentManagerModal;
